import React from 'react'
import { Box, Typography } from '@mui/material'

import { BaseIconProps } from '~assets/icons/BaseIcon'
import { lightTheme } from '~createTheme'

interface InputLabelProps {
  label: string
  isOptional?: boolean
  icon?: React.FC<BaseIconProps>
  iconColor?: string
}

const InputLabel: React.FC<InputLabelProps> = ({
  label,
  isOptional = false,
  icon: Icon,
  iconColor = lightTheme.palette.grey[600],
}) => {
  return (
    <Box display='flex' className='flex-v-align' gap={1} sx={{ mb: 1 }}>
      {Icon && iconColor && <Icon color={iconColor} width={24} />}
      <Typography variant='h3' noWrap>
        {label}
      </Typography>
      {isOptional && (
        <Typography
          variant='body2'
          fontWeight={'bold'}
          sx={{ color: lightTheme.palette.text.disabled }}
        >
          Optional
        </Typography>
      )}
    </Box>
  )
}

export default InputLabel
